import type { ReactNode } from 'react';

/** Calm empty state: states the next useful action, never a dead end. */
export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="lc-empty">
      <div className="lc-empty__title">{title}</div>
      {children ? <div>{children}</div> : null}
    </div>
  );
}
